const BaseUrlImage = process.env.REACT_APP_BASE_URL_IMAGE;
// const BaseUrlImage = 'http://localhost/linyay_backend/public/storage/';
// const BaseUrlImage = "https://dev-backend.linyay.com/storage/";

export default BaseUrlImage;